import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-version',
    templateUrl: './version.component.html',
    styleUrls: ['./version.component.scss']
})
export class VersionComponent implements OnInit {

    public version: string = '1.4.11';

    constructor() { }

    ngOnInit() {
    }

}